import useSWR from "swr";

export const useFetchAverageSatisfaction = (restaurantId: string) => {
  const { data: averageSatisfaction, error, isLoading } = useSWR<number>(`external_api/average-satisfaction/?restaurantId=${restaurantId}`)
  return { averageSatisfaction, isLoading, error };
};